// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3Dgeg","inner":"Footer_inner__3sUkM"};